var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Details",

    getDefaultProps () {
        return {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>3D2EC13F-9B73-4D96-A1B5-7B2273CA4BE4</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Header-01-EventGroup" transform="translate(-423.000000, -271.000000)" fill="currentColor">
      <g id="Tabs" transform="translate(240.000000, 259.000000)">
        <g id="details">
          <g transform="translate(183.000000, 12.000000)">
            <g id="Group-9">
              <path d="M0.145162826,15.8540233 C0.0552528722,15.7642222 0,15.6403324 0,15.5035173 L3.55271368e-15,2.99648272 C3.55271368e-15,2.72305431 0.223857625,2.5 0.5,2.5 C0.778067589,2.5 1,2.72228289 1,2.99648272 L1,15 L13.5017326,15 C13.7800934,15 14,15.2238576 14,15.5 C14,15.7780676 13.7769181,16 13.5017326,16 L0.498267412,16 C0.359677638,16 0.235577663,15.9445096 0.145893176,15.8547035 L0.145162826,15.8540233 Z M16,13.0043778 L16,0.995622154 C16,0.445755222 15.5500512,1.77635684e-15 15.0043778,1.77635684e-15 L2.99562215,0 C2.44575522,0 2,0.449948758 2,0.995622154 L2,13.0043778 C2,13.5542448 2.44994876,14 2.99562215,14 L15.0043778,14 C15.5542448,14 16,13.5500512 16,13.0043778 Z M2.99562215,13 C3.00013588,13 3,0.995622154 3,0.995622154 C3,1.00013588 15.0043778,1 15.0043778,1 C14.9998641,1 15,13.0043778 15,13.0043778 C15,12.9998641 2.99562215,13 2.99562215,13 Z M5.5,4 L12.5,4 L13,4 L13,3 L12.5,3 L5.5,3 L5,3 L5,4 L5.5,4 Z M5.5,6 L12.5,6 L13,6 L13,5 L12.5,5 L5.5,5 L5,5 L5,6 L5.5,6 Z M7.5,8 L12.5,8 L13,8 L13,7 L12.5,7 L7.5,7 L7,7 L7,8 L7.5,8 Z" id="details"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/details.svg
 **/